var map = {
	"./add.svg": 817,
	"./check-box_gray_on.svg": 462,
	"./check-box_off.svg": 463,
	"./check-box_on.svg": 566,
	"./check-box_parent.svg": 567,
	"./check-box_yellow_on.svg": 464,
	"./preparation.svg": 818,
	"./preparation_white.svg": 819,
	"./room.svg": 820,
	"./room_active.svg": 821,
	"./select.svg": 822,
	"./settle_gray.svg": 465,
	"./settle_orange.svg": 298,
	"./settle_white.svg": 466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2089;